import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faUser,
    faBars,
    faTachometerAlt,
    faCheckCircle,
    faAngleLeft,
    faAngleDown,
    faPoll,
    faSearch,
    faEdit,
    faTimesCircle,
    faPlus,
    faVideo,
    faMinusCircle
} from '@fortawesome/free-solid-svg-icons'

import {
    faCircle,
    faQuestionCircle,
    faImage
} from '@fortawesome/free-regular-svg-icons'

import {
    faGoogle,
    faFacebook,
    faPaypal
} from '@fortawesome/free-brands-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

[
    faUser,
    faBars,
    faTachometerAlt,
    faCheckCircle,
    faAngleLeft,
    faAngleDown,
    faCircle,
    faQuestionCircle,
    faPoll,
    faSearch,
    faImage,
    faEdit,
    faTimesCircle,
    faPlus,
    faGoogle,
    faFacebook,
    faPaypal,
    faVideo,
    faMinusCircle
].forEach(icon => {
    library.add(icon)
})

Vue.component('f-icon', FontAwesomeIcon)
